export const CHILDCARE_STOCK_THRESHOLD = 10;
export const BABY_CM_CHILDCARE_MIN_AGE = 4;
export const PETIT_CM_CHILDCARE_MIN_AGE = 24;
